import { EMEARegion, LARegion } from "@dana/Common/Constants";
import { setOrderTypeCartModeCookie } from "@dana/Common/utils";
import HiddenProductAddToCartButton from "@dana/Components/CheckAvailability/HiddenProductAddToCartButton";
import ProductAvailabilityQuantityOrdered from "@dana/Components/CheckAvailability/ProductAvailabilityQuantityOrdered";
import getProductAvilability, { InventryLocation, OrderType, OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import WarningIcon from "@dana/Icons/WarningIcon";
import InStock from "@dana/MobiusOverrides/Icons/InStock";
import OutOfStock from "@dana/MobiusOverrides/Icons/OutOfStock";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import ProductAddToCartButton, {
    ProductAddToCartButtonStyles,
} from "@dana/Overrides/Components/ProductAddToCartButton";
import ProductAddToListLink from "@dana/Overrides/Components/ProductAddToListLink";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import resetSelectedInventryLocations from "@dana/Store/Data/ProductAvailability/Handlers/ResetSelectedInventryLocationsHandler";
import updateSelectedInventryLocations, { SelectedInventryLocationsParameter } from "@dana/Store/Data/ProductAvailability/Handlers/SelectedInventryLocationsHandler";
import ProductAvailabilityState from "@dana/Store/Data/ProductAvailability/ProductAvailabilityState";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { LanguageModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox/Checkbox";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconMemo, IconThemableProps } from "@insite/mobius/Icon";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux"; // Add this import if using react-redux
import styled, { css } from "styled-components";
// Define or import mapStateToProps and mapDispatchToProps as needed

const mapStateToProps = (state: ApplicationStateDana) => {
    const currentLanguage = state.context.session.language;
    const languages = getLanguages(state);
    const currency = state.context.session?.currency;
    const isAuthenticated = state.context.session.isAuthenticated;
    const signInPageUrl = getPageLinkByPageType(state, "SignInPage")?.url;
    const canUserSeePrice = state?.showPriceToggle.canSeePrice ?? false;
    const locationsState = state.selectedInventryLocationsState;



    return {
        languages,
        currentLanguage,
        isAuthenticated,
        signInPageUrl,
        currency,
        canUserSeePrice,
        locationsState
    };
};
const mapDispatchToProps = {
    getProductAvilability,
    updateSelectedInventryLocations,
    resetSelectedInventryLocations
};

interface OwnProps {
    customErrorMessage: string;
    productAvilabilityModel?: ProductAvailabilityState;
    qty?: string;
    orderType?: string;
    setQty: (qty: number) => void;
    setOrderType: (orderType: OrderType) => void;
    orderTypeDisabled?: boolean;
    updateCartLine?: (qty: number, location: InventryLocation | undefined) => void;
    handleClose?: () => void;
    quantityDisabled: boolean
}

type Props = OwnProps &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

export interface ProductAvaibilityDetailsStyles {
    container?: GridContainerProps;
    orderTypeGridItem?: GridItemProps;
    orderType?: TypographyPresentationProps;
    orderSelect?: SelectPresentationProps;
    availabilityGridItem?: GridItemProps;
    currentAvailabilityTextWrapper?: InjectableCss;
    currentAvailabilityText?: TypographyPresentationProps;
    currentUnAvailabilityText?: TypographyPresentationProps;
    tooltipText?: TooltipPresentationProps;
    messageStyles?: InjectableCss;
    increaseQuantity?: InjectableCss;
    increaseQtyText?: TypographyPresentationProps;
    increaseQtyField?: TextFieldPresentationProps;
    locationTableGrid?: GridItemProps;
    locationTitle?: TypographyPresentationProps;
    locationCity?: TypographyPresentationProps;
    quantity?: TypographyPresentationProps;
    date?: TypographyPresentationProps;
    modalFooter?: GridItemProps;
    modalPricingContainer?: GridContainerProps;
    pricingDetails?: InjectableCss;
    pricingBox?: InjectableCss;
    priceLabel?: TypographyPresentationProps;
    priceAmount?: TypographyPresentationProps;
    addToListGrid?: GridItemProps;
    addToCartGrid?: GridItemProps;
    addToCartButtonStyle?: ProductAddToCartButtonStyles;
    errorMsgBox?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    addToCatrtButton?: ButtonPresentationProps;
    messageStylesWrapper?: InjectableCss;
    selectedQuantitywrapper?: InjectableCss;
    availableIcon?: IconThemableProps;
    notavailableIcon?: IconThemableProps;

}

export const productAvaibilityDetailsStyles: ProductAvaibilityDetailsStyles = {
    container: {
        gap: 0,
        isFullWidth: true,
    },
    orderTypeGridItem: {
        css: css`
            gap: 16px;
            padding-bottom: 24px;
        `,
    },
    orderType: {
        variant: "h2",
        css: css`
            margin-bottom: 0;
            flex-shrink: 0;
            flex: 1;
        `,
    },
    orderSelect: {
        cssOverrides: {
            formField: css`
                flex: 1;
            `,
        },
    },
    availabilityGridItem: {
        css: css`
            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
    currentAvailabilityTextWrapper: {
        css: css`
            flex: 1;
            align-items: center;
        `,
    },
    currentAvailabilityText: {
        weight: fontWeights.bold,
        color: themeBackgrounds.available,
        css: css`
            display: flex;
            align-items: center;
            gap: 4px;
        `,
    },
    currentUnAvailabilityText: {
        weight: fontWeights.bold,
        color: themeBackgrounds.notAvailable,
        css: css`
            display: flex;
            align-items: center;
            gap: 4px;
        `,
    },
    tooltipText: {
        mergeCss: true,
        cssOverrides: {
            tooltipBody: css`
                font-weight: ${fontWeights.regular};
            `,
        },
    },
    messageStyles: {
        css: css`
            margin: 16px 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            .info-message-box {
                display: block;
                font-size: ${fontSizes.small};
            }
            @media print {
                margin: 0 0 4px;
                .info-message-box {
                    font-size: ${fontSizes.xSmall};
                }
            }
        `,
    },
    increaseQuantity: {
        css: css`
            flex: 1;
            display: flex;
            align-items: flex-start;
            gap: 16px;
        `,
    },
    increaseQtyText: {
        size: fontSizes.small,
        lineHeight: lineHeights.default,
        color: themeBackgrounds.darkGray,
        css: css`
            text-align: right;

            @media screen and (max-width: 768px) {
                text-align: left;
            }
        `,
    },
    increaseQtyField: {
        cssOverrides: {
            formField: css`
                max-width: 80px;
            `,
        },
        css: css`
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
                opacity: 1;
                transform: scale(1.4);
            }
            -moz-appearance: number-input;`
    },
    locationTableGrid: {
        css: css`
            @media screen and (max-width: 768px) {
                table {
                    thead {
                        display: none;
                    }

                    tbody {
                        tr {
                            text-align: left;
                            padding-left: 40%;
                            position: relative;
                            border: 1px solid ${themeBackgrounds.lightGray};

                            td {
                                display: flex;
                                width: 100%;
                                gap: 10px;
                                flex-wrap: wrap;
                                border: none;

                                &::before {
                                    content: attr(data-label);
                                    left: 10px;                                    
                                    font-weight: ${fontWeights.regular};
                                    color: ${themeBackgrounds.darkGray};
                                }

                                span {
                                    display: flex;
                                    font-weight: ${fontWeights.semiBold};
                                    flex-wrap: wrap;
                                    color: ${themeBackgrounds.black};

                                    span {
                                        font-weight: ${fontWeights.regular};
                                        color: ${themeBackgrounds.darkGray};
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
    locationTitle: {
        weight: fontWeights.semiBold,
    },
    locationCity: {
        weight: fontWeights.regular,
        color: themeBackgrounds.darkGray,
    },
    quantity: {
        weight: fontWeights.semiBold,
        color: themeBackgrounds.darkGray,
    },
    date: {
        weight: fontWeights.semiBold,
        color: themeBackgrounds.darkGray,
    },
    modalFooter: {
        css: css`
            align-items: center;
            justify-content: space-between;
            padding-top: 24px;

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 20px;
            }

            .footer-info-text {
                font-size: ${fontSizes.small};
                line-height: ${lineHeights.default};
            }
        `,
    },
    modalPricingContainer: {
        offsetCss: css`
            flex-direction: row;
            justify-content: space-between;
            gap: 8px;
        `,
    },
    pricingDetails: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 24px;
        `,
    },
    pricingBox: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    priceLabel: {
        size: fontSizes.small,
        weight: fontWeights.semiBold,
        lineHeight: lineHeights.default,
    },
    priceAmount: {
        css: css`
            &.extended-price {
                font-weight: ${fontWeights.bold};
            }
        `,
    },
    addToListGrid: {
        css: css`
            justify-content: space-between;
            gap: 24px;
            [data-test-selector="addToListLink"],
            button {
                flex: 0 0 150px;
                min-width: 150px;
                padding-left: 5px;
                padding-right: 5px;
                text-align: center;
            }
        `,
    },
    addToCartGrid: {
        css: css`
            justify-content: flex-end;
            gap: 24px;
            [data-test-selector="addToCartBtn"],
            button {
                flex: 0 0 150px;
                min-width: 150px;
                padding-left: 5px;
                padding-right: 5px;
                text-align: center;
            }
        `,
    },
    addToCartButtonStyle: {
        button: {
            css: css`
                flex: 0 0 150px;
                min-width: 150px;
                padding-left: 5px;
                padding-right: 5px;
                text-align: center;
            `,
        },
        messageStylesWrapper: {
            css: css`
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                flex-shrink: 1;
                flex-basis: 100%;
                max-width: 100%;
                align-items: flex-start;
                gap: 24px;
            `,
        },
        messageStyles: {
            css: css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                .info-message-box {
                    display: block;
                    font-size: ${fontSizes.small};
                }
                @media print {
                    .info-message-box {
                        font-size: ${fontSizes.xSmall};
                    }
                }
            `,
        },
    },
    errorMsgBox: {
        css: css`
            display: flex;
            align-items: center;
            gap: 4px;
            margin-top: 8px;
            width: 100%;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    messageStylesWrapper: {
        css: css`
        justify-content: flex-end;
        `
    },
    addToCatrtButton: {
        css: css`
           min-width: 150px;
        `,
    },
};

const styles = productAvaibilityDetailsStyles;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    margin-top: 32px;

    thead {
        background-color: ${themeBackgrounds.white};

        th {
            font-size: ${fontSizes.xSmall};
            line-height: ${lineHeights.default};
            color: ${themeBackgrounds.darkGray};
        }

        td {
            color: ${themeBackgrounds.darkGray};
        }
    }

    tbody {
        td {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }
    }

    th,
    td {
        padding: 8px;
        border: 1px solid ${themeBackgrounds.lightGray};
        text-align: left;
        white-space: nowrap;
    }

    th:nth-child(1),
    td:nth-child(1) {
        min-width: 250px;
    }
`;

export const productQuantityOrderedStyles: TextFieldPresentationProps = {
    cssOverrides: {
        inputSelect: css`
            /* ISC-11023 deal with this. */
            /* stylelint-disable-next-line */
            -moz-appearance: textfield;

            width: 80px;
        `,
    },
    css: css`
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        opacity: 1;
        transform: scale(1.4);
    }
    -moz-appearance: number-input;
            `,
};

const ProductAvilabilityDetails = ({
    productContext: {
        product: { properties, id },
        productInfo: { qtyOrdered },
        onQtyOrderedChanged,
    },
    productAvilabilityModel,
    qty,
    orderType,
    setQty,
    setOrderType,
    isAuthenticated,
    signInPageUrl,
    currency,
    customErrorMessage,
    orderTypeDisabled = false,
    updateCartLine,
    canUserSeePrice,
    handleClose,
    updateSelectedInventryLocations,
    resetSelectedInventryLocations,
    locationsState,
    currentLanguage,
    languages,
    quantityDisabled
}: Props) => {
    if (productAvilabilityModel?.isLoading) {
        return (<LoadingSpinner></LoadingSpinner>)
    }
    const [selectedLanguage, setSelectedLanguage] = useState<LanguageModel>();
    const history = useHistory();
    const [selectedLocation, setLocation] = React.useState<string[]>();
    const [quantitySelectedstyles] = useState(() => mergeToNew(productQuantityOrderedStyles, productAvaibilityDetailsStyles.increaseQtyField));

    const formatDate = (isoString: string): string => {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat(currentLanguage?.languageCode).format(date);
    };
    const handleToggleLocation = (value: string) => {
        setLocation(prev => {
            if (!prev) return [value];
            return prev.includes(value)
                ? prev.filter(item => item !== value)
                : [...prev, value];
        });
    };
    const tarrif = productAvilabilityModel?.productCustomerPrice?.tarrif ? productAvilabilityModel?.productCustomerPrice?.tarrif : 0;
    const coreCharge = productAvilabilityModel?.productCustomerPrice?.coreCharge ? productAvilabilityModel?.productCustomerPrice?.coreCharge : 0;
    const coreChargeDisplay = productAvilabilityModel?.productCustomerPrice?.coreCharge ? productAvilabilityModel?.productCustomerPrice?.coreChargeDisplay : 0;
    const extendedPrice = (productAvilabilityModel?.productCustomerPrice?.extendedUnitListPriceDisplay ?? 0);
    const showAddToCart = properties?.showRtbCodeAddToCart;
    let totalQuantity = productAvilabilityModel?.productAvailability?.availableQuantity ?? 0;

    const handleOrderTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value as OrderType;
        setOrderType(value);
        setOrderTypeCartModeCookie(value);
    };

    useEffect(() => {
        if (orderType === OrderTypes.STOCK) {
            if (productAvilabilityModel && (productAvilabilityModel?.locations?.length ?? 0) > 0) {
                productAvilabilityModel?.locations.forEach(loc => {
                    handleToggleLocation(loc.id)
                });
                updateSelectedInventryLocations({
                    selectedLocations: productAvilabilityModel?.locations,
                    productId: id
                } as SelectedInventryLocationsParameter);
            }
        }
    }, [orderType]);

    useEffect(() => {
        const lang = languages?.find(l => l.id === currentLanguage?.id);
        setSelectedLanguage(lang)

    }, [currentLanguage]);

    useEffect(() => {

        if (!selectedLocation || selectedLocation?.length === 0) {
            resetSelectedInventryLocations({})
        } else {
            let tempLocations: InventryLocation[] = [];
            selectedLocation.forEach((id: string) => {
                if (tempLocations.find((p) => p.id === id) === undefined) {
                    const apiLocation = productAvilabilityModel?.locations?.find(loc => loc.id === id);
                    if (apiLocation) {
                        const newLocation = JSON.parse(JSON.stringify(apiLocation)) as InventryLocation;
                        if (newLocation) {
                            newLocation.selectedQuantity = Number(qty);
                            const currentLocations = JSON.parse(JSON.stringify(locationsState.selectedLocations)) as InventryLocation[];
                            const currentLocation = currentLocations.find((p) => p.id === newLocation.id);
                            if (currentLocation) {
                                newLocation.selectedQuantity = currentLocation.selectedQuantity;
                            }

                            tempLocations.push(newLocation);
                        }
                    }
                }
            });

            for (let i = 0; i < tempLocations.length; i++) {
                const location = tempLocations[i];
                if (!location.selectedQuantity) {
                    location.selectedQuantity = 0;
                }
            }

            updateSelectedInventryLocations({
                selectedLocations: tempLocations,
                productId: id
            } as SelectedInventryLocationsParameter);
        }

    }, [selectedLocation]);


    const addToCartClick = (): boolean => {
        if (updateCartLine) {
            const location = locationsState?.selectedLocations?.find(loc => selectedLocation?.includes(loc.id));
            updateCartLine(location?.selectedQuantity ?? Number(qtyOrdered), location);
            return true;
        }
        if (handleClose) {
            handleClose();
        }
        return false;
    }

    const redirectToSignInPage = () => {
        if (signInPageUrl) {
            if (handleClose) {
                handleClose();
            }
            history.replace(signInPageUrl);

        }
    };

    const handleSelect = (e: React.SyntheticEvent<Element, Event>, loc: InventryLocation) => {
        handleToggleLocation(loc.id);
    };

    const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === 13) {
            (event.target as any).blur();
        }
    };

    const debouncedQtyChangeHandler = debounce((event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        const locId = event.target.id.replace('sq-', '');
        let possibleNumber = Number(value);
        if (Number.isNaN(possibleNumber)) {
            return;
        }
        if (!locationsState.selectedLocations) {
            return;
        }

        const parsedQuantity = !Number.isNaN(qty) ? Number(qty) : 1;
        if (possibleNumber > parsedQuantity) {
            possibleNumber = parsedQuantity;
            event.target.value = possibleNumber.toString();
        }
        const updatedSelectedLocations = JSON.parse(JSON.stringify(locationsState.selectedLocations)) as InventryLocation[];
        let selectedLocation = updatedSelectedLocations?.find((p) => p.id === locId);
        if (!selectedLocation) {
            selectedLocation = productAvilabilityModel?.locations?.find(loc => loc.id === id);
            if (selectedLocation) {
                updatedSelectedLocations.push(JSON.parse(JSON.stringify(selectedLocation)) as InventryLocation);
            }
        }
        if (selectedLocation) {
            selectedLocation.selectedQuantity = possibleNumber;
            updateSelectedInventryLocations({
                selectedLocations: updatedSelectedLocations,
                productId: id
            } as SelectedInventryLocationsParameter);
        }
    }, 500);


    const getDefaultQty = (qty: any, commitedQty: any) => {
        return commitedQty >= qty ? qty : commitedQty
    }

    const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();      // stop default behavior
            event.stopPropagation();     // stop bubbling
            event.currentTarget.blur();  // trigger onBlur
        }
    };

    const blurHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        debouncedQtyChangeHandler(event);
    };

    return (
        <>
            <GridContainer {...styles.container}>
                <GridItem width={12} {...styles.orderTypeGridItem}>
                    {(orderType === OrderTypes.STOCK || (selectedLanguage && selectedLanguage.properties.region === LARegion)) && (
                        <Typography {...styles.orderType}>{translate("Stock Order")}</Typography>
                    )}
                    {orderType === OrderTypes.EMERGENCY && (selectedLanguage && selectedLanguage.properties.region !== LARegion) && (
                        <Typography {...styles.orderType}>{translate("Emergency Order")}</Typography>
                    )}
                    {(selectedLanguage && selectedLanguage.properties.region !== LARegion) && (
                        <Select
                            value={orderType}
                            disabled={orderTypeDisabled}
                            onChange={(event) => handleOrderTypeChange(event)}
                            {...styles.orderSelect}
                        >
                            <option key="PdetailsSTK" value={OrderTypes.STOCK}>
                                {translate("Stock Order")}
                            </option>
                            <option key="PdetailsEMG" value={OrderTypes.EMERGENCY}>
                                {" "}
                                {translate("Emergency Order")}
                            </option>
                        </Select>
                    )}

                </GridItem>
                <GridItem width={12} {...styles.availabilityGridItem}>
                    <StyledWrapper {...styles.currentAvailabilityTextWrapper}>
                        {totalQuantity > 0 ? (
                            <Typography {...styles.currentAvailabilityText}>
                                <Icon src={InStock}></Icon>{translate("In Stock")}{": "}
                                {totalQuantity} {" "} {translate("Available")}
                            </Typography>
                        ) : (
                            <Typography {...styles.currentUnAvailabilityText}>
                                <Icon src={OutOfStock}></Icon>{translate("Out Of Stock")}

                            </Typography>
                        )}

                    </StyledWrapper>
                    <StyledWrapper {...styles.increaseQuantity}>
                        <Typography {...styles.increaseQtyText}>
                            {translate("Increase Quantity to view additional availability details:")}
                        </Typography>
                        <ProductAvailabilityQuantityOrdered
                            labelOverride=""
                            extendedStyles={styles.increaseQtyField}
                            id={`${orderType}-qty`}
                            updatedQuantity={Number(qty)}
                            disabled={quantityDisabled !== undefined ? quantityDisabled : false}
                        />
                    </StyledWrapper>
                </GridItem>
                <GridItem width={12} {...styles.locationTableGrid}>
                    <StyledTable>
                        <thead>
                            <tr>
                                <th>{translate("Ship From Location")}</th>
                                <th> {translate("Qty")}</th>
                                {orderType === OrderTypes.EMERGENCY && (<th>{translate("Qty Selected")}</th>)}
                                <th> {translate("Estimated Ship Date")}</th>
                                {isAuthenticated && orderType === OrderTypes.EMERGENCY && (<th>{translate("Select")}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {productAvilabilityModel?.locations &&
                                productAvilabilityModel.locations.map((loc: InventryLocation) => {
                                    const repInfo = productAvilabilityModel?.productAvailability?.receiptInfo;
                                    const currentSelectedLoc = locationsState.selectedLocations?.find(x => x.id === loc.id);

                                    if (loc?.location?.name === 'Crossville' && Array.isArray(repInfo) && repInfo[0]?.committedQuantity === 0) {
                                        return <></>;
                                    }
                                    return (
                                        <tr key={Math.random()}>
                                            <td data-label={translate("Ship From Location :")}>
                                                <Typography {...styles.locationTitle}>
                                                    {loc?.location?.description},{" "}
                                                    <Typography {...styles.locationCity}>
                                                        {loc?.location?.city}, {loc?.location?.state}
                                                    </Typography>
                                                </Typography>
                                            </td>
                                            <td data-label={translate("Qty : ")}>
                                                <Typography {...styles.quantity}>{loc?.committedQuantity}</Typography>
                                            </td>
                                            {orderType === OrderTypes.EMERGENCY && (<td>
                                                <TextField
                                                    defaultValue={getDefaultQty(currentSelectedLoc?.selectedQuantity ?? qty, loc?.committedQuantity)}
                                                    type="number"
                                                    min={1}
                                                    max={loc?.committedQuantity}
                                                    data-test-selector="product_qtySelected"
                                                    onKeyDown={keyDownHandler}
                                                    onBlur={blurHandler}
                                                    // onKeyPress={keyPressHandler}
                                                    // onChange={qtyChangeHandler}
                                                    {...quantitySelectedstyles}
                                                    id={`sq-${loc.id}`}
                                                    disabled={!selectedLocation || !selectedLocation.includes(loc?.id)}
                                                />
                                            </td>)}
                                            <td data-label={translate("Estimated Ship Date : ")}>
                                                <Typography {...styles.date}>{loc?.committedDate ? formatDate(loc?.committedDate) : ""}</Typography>
                                            </td>
                                            {isAuthenticated && orderType === OrderTypes.EMERGENCY && (<td>
                                                <Checkbox
                                                    checked={selectedLocation && selectedLocation.length > 0 && selectedLocation.includes(loc?.id)}
                                                    onChange={(e) => handleSelect(e, loc)}
                                                />
                                            </td>)}

                                        </tr>
                                    );
                                })}
                        </tbody>
                    </StyledTable>
                </GridItem>
                {customErrorMessage && (
                    <GridItem width={12}>
                        <StyledWrapper {...styles.errorMsgBox}>
                            <IconMemo src={WarningIcon} size={16} />
                            <Typography>{customErrorMessage}</Typography>
                        </StyledWrapper>
                    </GridItem>
                )}

                <GridItem width={12} {...styles.modalFooter}>
                    <GridContainer gap={0} {...styles.modalPricingContainer}>
                        {showAddToCart === "true" && canUserSeePrice && (
                            <>
                                <GridItem width={12}>
                                    <StyledWrapper className="pricing-details-row" {...styles.pricingDetails}>
                                        <StyledWrapper className="unit-price" {...styles.pricingBox}>
                                            <Typography {...styles.priceLabel}>
                                                {translate("Unit Price ({0})", currency?.currencyCode ?? "USD")}{" "}
                                                <Tooltip
                                                    {...styles.tooltipText}
                                                    text={selectedLanguage && selectedLanguage.properties.region !== EMEARegion ?
                                                        translate("Pricing displayed represents your current, agreed, every-day, \"Standard Net Price\", and does not reflect any special / promotional pricing or discounts that may be available. If you have questions, please contact Customer Operations at (800) 621-8084.")
                                                        : translate("Pricing displayed represents your current, agreed, every-day, \"Standard Net Price\", and does not reflect any special / promotional pricing or discounts that may be available. If you have questions, please contact Customer Operations at cvameurope@dana.com.")
                                                    }
                                                />
                                            </Typography>
                                            <Typography {...styles.priceAmount}>
                                                {productAvilabilityModel?.productCustomerPrice?.unitListPriceDisplay}
                                            </Typography>
                                        </StyledWrapper>
                                        {tarrif > 0 && (selectedLanguage && selectedLanguage.properties.region !== EMEARegion) && (
                                            <StyledWrapper className="unit-tarrif-fee" {...styles.pricingBox}>
                                                <Typography {...styles.priceLabel}>
                                                    {translate("Unit Tariff Fee ({0})", currency?.currencyCode ?? "USD")}{" "}
                                                </Typography>
                                                <Typography {...styles.priceAmount}>
                                                    {currency?.currencySymbol ?? "$"}{new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(tarrif)}
                                                </Typography>
                                            </StyledWrapper>)}
                                        {coreCharge > 0 && (selectedLanguage && selectedLanguage.properties.region !== EMEARegion) && (
                                            <StyledWrapper className="unit-core-deposit" {...styles.pricingBox}>
                                                <Typography {...styles.priceLabel}>
                                                    {translate("Unit Core Deposit ({0})", currency?.currencyCode ?? "USD")}{" "}
                                                </Typography>
                                                <Typography {...styles.priceAmount}>
                                                    {coreChargeDisplay}
                                                </Typography>
                                            </StyledWrapper>)}
                                        <StyledWrapper className="extended-price" {...styles.pricingBox}>
                                            <Typography {...styles.priceLabel}>
                                                {translate("Extended Price ({0})", currency?.currencyCode ?? "USD")}
                                            </Typography>
                                            <Typography {...styles.priceAmount} className="extended-price">
                                                {extendedPrice}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </GridItem>
                            </>
                        )}

                        <GridItem width={12}  {...styles.addToCartGrid}>
                            {showAddToCart === "true" && canUserSeePrice && orderType === OrderTypes.EMERGENCY && ((selectedLocation && selectedLocation?.length === 0) || !selectedLocation || (selectedLanguage && selectedLanguage.properties.region === EMEARegion && productAvilabilityModel?.productCustomerPrice?.unitListPrice === 0)) ?
                                <HiddenProductAddToCartButton
                                    data-test-selector="addToCartBtnHidden"
                                    extendedStyles={styles.addToCartButtonStyle}                                   
                                    labelOverride={translate("Add To Cart")}
                                />
                               

                                :
                                <ProductAddToCartButton
                                    data-test-selector="addToCartBtn"
                                    extendedStyles={styles.addToCartButtonStyle}
                                    isEditMode={orderTypeDisabled}
                                    onAddToCartClick={addToCartClick}
                                    productAvilabilityModel={productAvilabilityModel}
                                    labelOverride={orderTypeDisabled ? translate("Edit Quantity") : translate("Add To Cart")}
                                />

                            }

                        </GridItem>
                        <GridItem width={12} {...styles.addToListGrid}>
                            <Typography className="footer-info-text">

                            </Typography>
                            {isAuthenticated ? (
                                <ProductAddToListLink data-test-selector="addToListLink" classes="btn btn-secondary" />
                            ) : (
                                <Button variant="secondary" onClick={redirectToSignInPage}>{translate("Add To List")}</Button>
                            )}{" "}
                        </GridItem>
                    </GridContainer>
                </GridItem >
            </GridContainer >
        </>
    );
};

export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductAvilabilityDetails));
